/**
 * Upgrade do solitário — script clássico (não depende do module andrade-pdp.js).
 * Atualiza o aviso de presente e soma o upgrade no Pix / parcelas.
 */
(function () {
  if (window.__andradeSolitarioUpgradeBound) return;
  window.__andradeSolitarioUpgradeBound = true;

  function formatBRL(cents) {
    var n = Math.round(Number(cents) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts[0] + ',' + parts[1];
  }

  function fillTemplate(tpl, token, value) {
    if (!tpl) return value;
    if (tpl.indexOf(token) >= 0) return tpl.split(token).join(value);
    return value;
  }

  function pdpRoot() {
    return document.querySelector('[data-md-pdp]');
  }

  function upgradeWraps() {
    var root = pdpRoot();
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-md-kit-upgrade], [data-md-solitario-upgrade]'));
  }

  function attrFrom(el, name) {
    if (!el) return '';
    return el.getAttribute(name) || '';
  }

  function selectedRadio(wrap) {
    if (!wrap) return null;
    return wrap.querySelector('[data-md-solitario-upgrade-option]:checked');
  }

  function applyUpgradeUi() {
    var root = pdpRoot();
    var wraps = upgradeWraps();
    if (!root) return;

    var extraFull = 0;
    var pct = 15;
    var anyActive = false;

    wraps.forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-md-solitario-upgrade-toggle]');
      var radio = selectedRadio(wrap);
      var toggleOn = !!(toggle && toggle.checked);
      var hasModel = !!(radio && (attrFrom(radio, 'data-variant-id') || attrFrom(radio, 'data-price-cents')));
      var active = toggleOn && hasModel;
      if (active) {
        anyActive = true;
        extraFull += Number(attrFrom(radio, 'data-price-cents') || 0);
        pct = Number(attrFrom(wrap, 'data-discount-percent') || pct);
      }
      var panel = wrap.querySelector('[data-md-solitario-upgrade-panel]');
      if (panel) panel.hidden = !toggleOn;
      wrap.classList.toggle('is-open', toggleOn);

      var totalEl = wrap.querySelector('[data-md-upgrade-total]');
      if (totalEl && !active) {
        totalEl.hidden = true;
        totalEl.textContent = '';
      }
    });

    if (!anyActive) return;

    var kit = Number(root.getAttribute('data-variant-price') || 0);
    var total = kit + extraFull;
    if (anyActive && pct > 0) {
      total = Math.floor((total * (100 - pct)) / 100);
    }
    var pixPct = Number(root.getAttribute('data-pix-discount') || 5);
    var inst = Number(root.getAttribute('data-installments') || 10) || 10;
    var pix = Math.floor((total * (100 - pixPct)) / 100);
    var pixSaved = total - pix;
    var showPixDeal = pixPct > 0 && pixSaved > 0;
    var installment = Math.round(total / inst);
    var pixMoney = formatBRL(pix);
    var instMoney = formatBRL(installment);

    document.querySelectorAll('[data-md-pix-block]').forEach(function (el) {
      el.hidden = !showPixDeal;
    });
    document.querySelectorAll('[data-md-pix]').forEach(function (el) {
      var tpl = el.getAttribute('data-template') || '__PRICE__ no Pix';
      el.textContent = fillTemplate(tpl, '__PRICE__', pixMoney);
    });
    document.querySelectorAll('[data-md-pix-savings]').forEach(function (el) {
      if (!showPixDeal) {
        el.hidden = true;
        return;
      }
      el.hidden = false;
      var tpl = el.getAttribute('data-template') || '__AMOUNT__ de desconto no Pix (__PERCENT__%)';
      el.textContent = fillTemplate(
        fillTemplate(tpl, '__AMOUNT__', formatBRL(pixSaved)),
        '__PERCENT__',
        String(pixPct)
      );
    });
    document.querySelectorAll('[data-md-installments]').forEach(function (el) {
      var tpl = el.getAttribute('data-template') || 'ou __COUNT__x de __PRICE__ sem juros';
      el.textContent = fillTemplate(fillTemplate(tpl, '__COUNT__', String(inst)), '__PRICE__', instMoney);
    });
    document.querySelectorAll('[data-md-sticky-price]').forEach(function (el) {
      var pixEl = document.querySelector('[data-md-pix]');
      if (showPixDeal && pixEl) {
        el.textContent = pixEl.textContent;
        return;
      }
      el.textContent = formatBRL(total);
    });

    wraps.forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-md-solitario-upgrade-toggle]');
      var radio = selectedRadio(wrap);
      var active = !!(toggle && toggle.checked && radio);
      var totalEl = wrap.querySelector('[data-md-upgrade-total]');
      if (totalEl && (active || anyActive)) {
        var totalTpl = totalEl.getAttribute('data-template') || 'Total com upgrade: __PRICE__ no Pix';
        totalEl.textContent = fillTemplate(totalTpl, '__PRICE__', pixMoney);
        totalEl.hidden = !anyActive;
      }
    });
  }

  function bindUpgradeCarousels() {
    document.querySelectorAll('[data-md-upgrade-carousel]').forEach(function (el) {
      var viewport = el.querySelector('[data-md-upgrade-viewport]');
      var prev = el.querySelector('[data-md-upgrade-prev]');
      var next = el.querySelector('[data-md-upgrade-next]');
      if (!viewport) return;

      function updateNav() {
        var max = viewport.scrollWidth - viewport.clientWidth - 4;
        var scrollable = viewport.scrollWidth > viewport.clientWidth + 4;
        el.classList.toggle('is-scrollable', scrollable);
        if (prev) prev.disabled = !scrollable || viewport.scrollLeft <= 2;
        if (next) next.disabled = !scrollable || viewport.scrollLeft >= max;
      }

      if (el.getAttribute('data-carousel-bound') === 'true') {
        updateNav();
        return;
      }
      el.setAttribute('data-carousel-bound', 'true');

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
        });
      }
      viewport.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      window.setTimeout(updateNav, 50);
      updateNav();
    });
  }

  function selectCard(card, wrap) {
    if (!card || !wrap) return;
    var radio = card.querySelector('[data-md-solitario-upgrade-option]');
    if (radio) radio.checked = true;
    wrap.querySelectorAll('[data-md-solitario-upgrade-option]').forEach(function (el) {
      if (el !== radio) el.checked = false;
    });
    var toggle = wrap.querySelector('[data-md-solitario-upgrade-toggle]');
    if (toggle) toggle.checked = true;
  }

  function onPointer(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var wrap = target.closest('[data-md-kit-upgrade], [data-md-solitario-upgrade]');
    if (!wrap) return;
    if (target.closest('[data-md-upgrade-prev], [data-md-upgrade-next]')) return;
    if (target.closest('.md-pdp-solitario-upgrade__toggle')) return;
    var card = target.closest('.md-pdp-solitario-upgrade__card');
    if (card) selectCard(card, wrap);
    window.setTimeout(applyUpgradeUi, 0);
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var wrap = target.closest('[data-md-kit-upgrade], [data-md-solitario-upgrade]');
    if (!wrap) return;

    if (target.getAttribute('data-md-solitario-upgrade-toggle') != null && !target.checked) {
      wrap.querySelectorAll('[data-md-solitario-upgrade-option]').forEach(function (el) {
        el.checked = false;
      });
    }
    if (target.getAttribute('data-md-solitario-upgrade-option') != null && target.checked) {
      var toggle = wrap.querySelector('[data-md-solitario-upgrade-toggle]');
      if (toggle) toggle.checked = true;
    }
    applyUpgradeUi();
  }

  document.addEventListener('pointerup', onPointer, true);
  document.addEventListener('click', onPointer, true);
  document.addEventListener('change', onChange, true);
  document.addEventListener('input', onChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyUpgradeUi();
      bindUpgradeCarousels();
    });
  } else {
    applyUpgradeUi();
    bindUpgradeCarousels();
  }

  window.AndradeSolitarioUpgrade = {
    apply: function () {
      applyUpgradeUi();
      bindUpgradeCarousels();
    },
  };
})();
